import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CourseUnitFeed from "CurriculumMaps/common/CourseUnitFeedRoute";

export default store => ({
  path: "course-map",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "curriculum-maps" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [CourseUnitFeed(store)],
});
